/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';

export const headerMenuPanelSX: SxProps = {
	width: '385px',
	maxHeight: '80vh',
	'& .MuiPaper-root': {
		maxWidth: 'none',
		width: '385px',
	},
};

export const headerDrawerContainerSX: SxProps = {
	'& .MuiDrawer-paper': {
		maxHeight: '80vh',
		zIndex: '1600',
		bottom: '60px',
		boxShadow: 3,
		transition: 'none',
	},
};
